"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/GenericSelect/GenericEntityOption.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _keyboard = require('web/services/keyboard');














const GenericEntityOption = (
  props,
) => {
  if ('isEmpty' in props) {
    return (
      _react2.default.createElement('div', {
        role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
        onClick: props.onSelect,
        className: _classBuilder2.default.call(void 0, 
          "blm-generic-entity-option",
          "blm-generic-entity-option--empty",
          "blm-generic-entity-option--preview",
          props.className,
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}

        ,  props.children 
      )
    )
  }

  const {
    option, name, description, isSelected,
    isPreviewOption, isPreviewOptionFocused, onSelect, Avatar,
  } = props

  return (
    _react2.default.createElement('div', {
      role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
      onClick: onSelect,
      className: _classBuilder2.default.call(void 0, 
        "blm-generic-entity-option",
        isPreviewOption && "blm-generic-entity-option--preview",
        isPreviewOption && isPreviewOptionFocused && "blm-generic-entity-option--preview-focused",
        props.className,
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}

      , _react2.default.createElement(Avatar, {
        size: 30,
        option: option,
        className: "blm-generic-entity-option--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}}
      )
      , _react2.default.createElement('div', { className: "blm-generic-entity-option--info", __self: this, __source: {fileName: _jsxFileName, lineNumber: 62}}
        , _react2.default.createElement('span', { className: "blm-generic-entity-option--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}},  name )
        ,  description && (
          _react2.default.createElement('span', { className: "blm-generic-entity-option--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}},  description )
        )
      )
      ,  isSelected && !isPreviewOption && (
        _react2.default.createElement('div', { className: "blm-generic-entity-option--check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}} )
      )
    )
  )
}

exports. default = GenericEntityOption
